export enum GATEWAY_TYPE {
  CPONE = 'CPONE',
  CPEDGE = 'CPEDGE',
  CPLIGHT = 'CPLIGHT',
  GENERIC = 'GENERIC',
  ARGOS_GATEWAY = 'ARGOS_GATEWAY'
}
